module.exports = __webpack_public_path__ + "static/media/classes_dance_fitness_class.750023c4.webp";